// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2Se2E","resendInfoText":"OnGoingPaymentBox_resendInfoText__1STXW"};